import { useState } from "react";
// Limitless imports
import { log } from "@limitless/common/utils";
import { resendSignUpRegistrationCode, confirmSignUpRegistrationCode } from "@limitless/expert/apis/sign-up-api/SignUpAPI";
const MAX_CODE_LENGTH = 6;
const INITIAL_STATE = {
  loading: false,
  code: null,
  errTxt: null,
  btnVisible: false,
  verifyFailed: false,
  checkEmail: false
};
export const useVerify = () => {
  const [verifySignUpState, setVerifySignUpState] = useState(INITIAL_STATE);
  const [clearCodes, setClearCodes] = useState(false);
  const showResendEmailTxt = () => {
    setVerifySignUpState({
      ...INITIAL_STATE,
      checkEmail: true
    });
    const timeOut = setTimeout(() => {
      setVerifySignUpState({
        ...INITIAL_STATE,
        checkEmail: false
      });
      clearTimeout(timeOut);
    }, 10000);
  };
  const verifyButtonHandler = (email, registrationUrl) => () => {
    log.debug(`verifyButtonHandler: email: ${email} code: ${verifySignUpState.code}`);
    setVerifySignUpState({
      ...INITIAL_STATE,
      loading: true
    });

    // LD-15665 — pass the captured onboarding URL through to the confirm call as ClientMetadata.
    return confirmSignUpRegistrationCode(email, verifySignUpState.code, registrationUrl).then(() => {
      setVerifySignUpState({
        ...INITIAL_STATE,
        verifyFailed: false,
        loading: false
      });
      setClearCodes(true);

      // Get all the credentials from localStorage and send it to the EWA page
      window.location.assign(process.env.REACT_APP_PORTAL_URL);
    }).catch(err => {
      log.error(`confirmSignUpRegistrationCode Err: ${err.message || err}`);
      setVerifySignUpState({
        ...INITIAL_STATE,
        verifyFailed: true,
        loading: false
      });
    });
  };
  const resendButtonHandler = email => () => {
    log.debug(`resendButtonHandler email: ${email}`);
    setVerifySignUpState({
      ...INITIAL_STATE,
      loading: true
    });
    setClearCodes(false);
    return resendSignUpRegistrationCode(email).then(() => {
      setClearCodes(true);
      setVerifySignUpState({
        ...INITIAL_STATE
      });
      showResendEmailTxt();
    }).catch(err => {
      const errTxt = err.message || err;
      log.error(`resendButtonHandler Err: ${errTxt}`);
      setVerifySignUpState({
        ...INITIAL_STATE,
        errTxt
      });
    });
  };
  const updateCodeCollector = code => {
    if (code.length === MAX_CODE_LENGTH) {
      setVerifySignUpState({
        ...INITIAL_STATE,
        btnVisible: true,
        code
      });
    } else {
      setVerifySignUpState({
        ...INITIAL_STATE
      });
    }
  };
  return {
    maxLength: MAX_CODE_LENGTH,
    clearCodes,
    verifySignUpState,
    verifyButtonHandler,
    resendButtonHandler,
    updateCodeCollector
  };
};